import React, { Component } from 'react';
import Switch from "react-switch";
import { toast } from 'react-toastify';
import { Popover, OverlayTrigger } from "react-bootstrap";
import { renderToStaticMarkup } from 'react-dom/server';
import QRCode from 'qrcode.react';

import CustomModal from "../../../components/Modal/CustomModal";
import ModalReports from '../../../components/Reportes/ModalReports';
import ConstanciaEst from '../../../components/Reportes/ConstanciaEst';
import { SvgToPng } from "../../../funciones/AdmisionFunction";


import { ConsultCarrera, NoAceptar, AceptarConst } from "../../../funciones/ConstanciaFunction"

class ConstPendientes extends Component {
    state = {
        preloadCarrera: {
            icon: "fa fa-spinner fa-spin",
            text: "Cargando"
        },
        openCancel: false,
        openOk: false,
        openReporte: false,
        modalBtn1: {
            icon:"fa fa-check",
            text: "Si"
        },
        check: true,
        dataRep: "",
        datosEst: "",
        qr: "",
    }

    constructor (props) {
        super (props);
        ConsultCarrera (props.datos.id_est, (resp) =>{
            this.setState({
                preloadCarrera: {
                    icon: "",
                    text: resp.carrera_name
                },
            })
        })
    }

    openModal = (modal, cancel1) => () => {
        this.setState ({
            [modal]: true,
            [cancel1]: false,
            openReporte: false,
        })
    }

    modalCancel = () => {
        const { openCancel, modalBtn1 } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>¿Deseas realmente <strong className="text-danger">Cancelar</strong> esta solicitud de Constancia de Estudios?</div>
                <div style={{fontSize: 11}}>Se le enviará un Email de notificación al estudiante</div>
            </React.Fragment>
        )

        let noAceptar = (id) => () => {
            this.setState({
                modalBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera"
                }
            }, () => {
                NoAceptar (id, () => {
                    this.setState({
                        openCancel: false,
                        modalBtn1: {
                            icon:"fa fa-check",
                            text: "Si"
                        },
                    }, () => {
                        this.props.updateList();
                        toast.info("Has cancelado correctamente la solicitud",{autoClose: 4000});
                    })
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icon}></i> {modalBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openCancel}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {noAceptar(this.props.datos.id)}
            />
        );
    }

    modalOk = () => {
        
        const { openOk, modalBtn1, check } = this.state;

        let Aceptar = (id) => () => {
            this.setState({
                modalBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Generando el Formato"
                }
            }, () => {
                let imgSvg = (
                    <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar?code=${this.props.datos.token.substring(0,10)}`}/>
                )
        
                const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
                const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;
        
                SvgToPng (dataUri, (qr) => {
                    this.setState({ qr: qr })
                })
                
                AceptarConst (id, check, (resp) => {
                    this.setState({
                        check: true,
                        openOk: false,
                        openReporte: true,
                        modalBtn1: {
                            icon:"fa fa-check",
                            text: "Si"
                        },
                        dataRep: resp[0],
                        datosEst: resp[1]
                    }, () => {
                        /* this.props.updateList(); */
                    })
                })
            })
        }

        let contenido = () => (
            <React.Fragment>
                <div>Vas a proceder a <strong className="text-primary">Aceptar</strong> esta solicitud de Constancia de Estudios. Si presionas <strong>Si</strong> se cargará el formato para imprimir. ¿Deseas continuar?</div>
                <Switch height={12} onChange={
                    () => { this.setState({ check: !this.state.check }) }
                } width={24} checked={check} /> <span style={{fontSize: 11}}>Enviar un Email de notificación al estudiante</span>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalBtn1.icon}></i> {modalBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openOk}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {Aceptar(this.props.datos.id)}
            />
        );
    }

    modalReporte = () => {
        const { openReporte, dataRep, datosEst } = this.state;

        if (openReporte === false) return null;

        let { datos } = this.props;

        let nombre = (nom1, nom2, ape1, ape2) => {
            if (nom2 === null) nom2 = "";
            if (ape2 === null) ape2 = "";
            return `${nom1} ${nom2} ${ape1} ${ape2}`
        }

        let contenidoModal = () => (
            <ConstanciaEst
                datos= {datosEst}
                token = {dataRep.token}
                fecha = {dataRep.fecha}
                qr = {this.state.qr}
            />
        )

        return (
            <ModalReports
                reporte={contenidoModal()}
                titulo={`Constancia de Estudios de ${nombre(datos.nombre_1, datos.nombre_2, datos.apellido_1, datos.apellido_2)}`}
                display= "block"
                cerrar = {() => {
                    this.setState({
                        openReporte:false
                    }, () => {
                        this.props.updateList();
                    })
                }}
            />
        )
    }

    render() {
        let { datos } = this.props;
        let { preloadCarrera } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let nombre = (nom1, nom2, ape1, ape2) => {
            if (nom2 === null) nom2 = "";
            if (ape2 === null) ape2 = "";
            return `${nom1} ${nom2} ${ape1} ${ape2}`
        }

        let MenuContent = () => (
            <Popover bsSize="large" id="menuItems">
                <div className="text-primary" onClick={this.openModal("openOk", "openCancel")} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-check"></i> Aprobar e Imprimir</div>
                <div className="text-danger" onClick={this.openModal("openCancel", "openOk")} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-times"></i> Cancelar Solicitud</div>
            </Popover>
        )

        return (
            <React.Fragment>
                <tr>
                    <td align="center" style={styles}>{`${datos.nacionalidad} ${datos.ci}`}</td>
                    <td style={styles}>{nombre(datos.nombre_1, datos.nombre_2, datos.apellido_1, datos.apellido_2)}</td>
                    <td align="center" style={styles}><i className={preloadCarrera.icon}></i> {preloadCarrera.text}</td>
                    <td align="center" style={styles}>
                        <OverlayTrigger trigger="focus" placement="right" overlay={MenuContent()}>
                            <button className="btn btn-primary" style={{borderWidth: 1}}><i className="fa fa-gear"></i> Acciones</button>
                        </OverlayTrigger>
                    </td>
                </tr>
                {this.modalCancel()}
                {this.modalOk()}
                {this.modalReporte()}
            </React.Fragment>
        );
    }
}
 
export default ConstPendientes;


// WEBPACK FOOTER //
// ./src/views/Reportes/ConstanciaContent/ConstPendientes.jsx